import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
import useAbility from '@/plugins/useAbility';
import { legacyAnalyticsDestination } from './utils/analyticsRoutes.mjs';

const analyticsMeta = (translationKey, isNextAppPage = false) => ({
  allowAnonymous: false,
  ability: { subject: USER_SUBJECTS.ANALYTICS, action: USER_ACTIONS.READ },
  breadcrumb: { leafTranslationKey: translationKey },
  isNextAppPage,
});

const moduleRoutes = [
  { path: '/analytics', name: 'Analytics', redirect: legacyAnalyticsDestination },
  {
    path: '/analytics/user-activity',
    name: 'AnalyticsUserActivity',
    component: () => import('./pages/AnalyticsUserActivity.vue'),
    meta: {
      ...analyticsMeta('analytics.userActivity', true),
      ability: { subject: USER_SUBJECTS.COMPANY_USERS, action: USER_ACTIONS.READ },
    },
  },
  {
    path: '/analytics/work-center-efficiency',
    name: 'AnalyticsWorkCenterEfficiency',
    component: () => import('./pages/AnalyticsWorkCenterEfficiency.vue'),
    meta: analyticsMeta('analytics.workCenterEfficiency', true),
  },
  {
    path: '/analytics/performance',
    name: 'AnalyticsPerformance',
    component: () => import('./pages/AnalyticsPerformance.vue'),
    meta: analyticsMeta('analytics.performance', true),
  },
  {
    path: '/analytics/overview',
    name: 'AnalyticsOverview',
    component: () => import('./pages/AnalyticsOverview.vue'),
    meta: analyticsMeta('analytics.overview', true),
  },
  {
    path: '/analytics/oee',
    name: 'AnalyticsOee',
    component: () => import('./pages/AnalyticsOee.vue'),
    meta: analyticsMeta('analytics.oee', true),
  },
  {
    path: '/analytics/downtimes',
    name: 'AnalyticsDowntimeReasons',
    component: () => import('./pages/AnalyticsDowntimeReasons.vue'),
    meta: analyticsMeta('analytics.downtimes', true),
  },
  {
    path: '/analytics/output',
    name: 'AnalyticsOutput',
    component: () => import('./pages/AnalyticsOutput.vue'),
    meta: analyticsMeta('analytics.output', true),
  },
  {
    path: '/analytics/quality',
    name: 'AnalyticsQuality',
    component: () => import('./pages/AnalyticsQuality.vue'),
    meta: analyticsMeta('analytics.quality', true),
  },
  {
    path: '/analytics/classification-response',
    name: 'AnalyticsClassificationResponse',
    component: () => import('./pages/AnalyticsClassificationResponse.vue'),
    meta: analyticsMeta('analytics.classificationResponse', true),
  },
  {
    path: '/analytics/energy',
    name: 'AnalyticsEnergy',
    component: () => import('./pages/AnalyticsEnergy.vue'),
    meta: analyticsMeta('analytics.energyConsumption'),
  },
  {
    path: '/analytics/checklists',
    name: 'AnalyticsChecklists',
    component: () => import('./pages/AnalyticsChecklists.vue'),
    meta: analyticsMeta('analytics.checklists'),
    beforeEnter: (_to, _from, next) => {
      next(
        useAbility().can(USER_ACTIONS.READ, USER_SUBJECTS.CHECKLISTS)
          ? undefined
          : { name: 'WorkCenters' },
      );
    },
  },
];

export default (router) => {
  for (const route of moduleRoutes) {
    router.addRoute(ROUTE_NAMES.BASE_LAYOUT, route);
  }
};
